/* eslint-disable class-methods-use-this */
import React from 'react';
import { Alert } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import { ServerError, ServerErrorResponse } from 'data_sources/constants';
import { Warning } from '@mui/icons-material';
import { enqueueSnackbar } from 'notistack';
import { isArray } from 'lodash';
export default class errorHelper {
  static renderErrors = (query: any) => {
    if (!query.error) return null;
    let message = t('errors.3');
    let code: number | null = null;
    if (query.error?.response?.status === 403) {
      message = t('errors.forbidden');
    } else if (query.error?.response?.message?.length > 0) {
      message = query.error?.response?.message;
    } else if (query.error?.message?.length > 0) {
      try {
        const err = JSON.parse(query.error.message);
        if (err) {
          message = err.detail;
          code = err.errorInformationCode;
        }
      } catch (e) {
        message = query.error.toString();
      }
    }

    return <Alert severity='error'>{t(`errors.${code}`) || message}</Alert>;
  };
  static renderAllErrors = (serverErrors?: ServerErrorResponse, schemaErrors?: object, useMessage?: boolean) => {
    const errorDetails: ServerError[] = [];
    // Handle null or undefined errorDetails gracefully
    if (serverErrors && Array.isArray(serverErrors.errorDetails) && serverErrors.errorDetails.length > 0) {
      serverErrors.errorDetails.forEach((e) => errorDetails.push(e));
    } else if (serverErrors) {
      const rootError: ServerError = {
        code: serverErrors?.errorInformationCode || 0,
        detail: serverErrors?.detail || '',
        message: serverErrors?.errorMessage || serverErrors?.message || '',
      };
      errorDetails.push(rootError);
    }
    if (schemaErrors && Object.keys(schemaErrors).length > 0) {
      Object.entries(schemaErrors).forEach(([k, v]) => {
        if (isArray(v)) {
          v.forEach((x) => {
            errorDetails.push({
              code: 0,
              detail: x.message,
              message: x.message,
            });
          });
        } else {
          errorDetails.push({
            code: 0,
            detail: v.message,
            message: v.message,
          });
        }
      });
    }

    return errorDetails && errorDetails.length > 0 ? (
      <Alert
        icon={<Warning />}
        severity='error'
        sx={{ alignItems: 'center', mb: 5 }}
      >
        <ul
          className='error-list'
          style={{ margin: '2px 0' }}
        >
          {errorDetails.map((x, i) => (
            <li
              key={`server_errors_${i}`}
              data-errors={JSON.stringify(x?.detail)}
            >
              {(() => {
                const translatedError = t(`errors.${x.code}`);
                // Prioritize detail field if it contains meaningful information
                if (!useMessage && x.detail && x.detail.trim()) {
                  return x.detail;
                }
                // Fall back to translated error or message
                return translatedError?.includes('%') ? translatedError : translatedError || x.message;
              })()}
            </li>
          ))}
        </ul>
      </Alert>
    ) : null;
  };

  static enqueueErrors = (errors: ServerErrorResponse | Error) => {
    let parsed: ServerErrorResponse;
    if (errors instanceof Error) {
      try {
        parsed = JSON.parse(errors.message) as ServerErrorResponse;
      } catch {
        enqueueSnackbar(errors.message || 'An unexpected error occurred.', { variant: 'error' });
        return;
      }
    } else {
      parsed = errors;
    }

    let message = parsed?.message || 'An unexpected error occurred.';
    let code: number | null = parsed.errorInformationCode || null;
    if (code === 403) {
      message = t('errors.forbidden');
    } else if (parsed?.message?.length && parsed?.message?.length > 0) {
      message = parsed.message;
    } else if (parsed?.detail?.length && parsed?.detail?.length > 0) {
      message = parsed.detail;
    }

    const hasDetailedErrors = parsed?.errorDetails && parsed.errorDetails.length > 0;
    if (hasDetailedErrors) {
      const detailedMessages = parsed.errorDetails!.map((e) =>
        e.message || `${t(`errors.${e.code}`)}: ${e.detail}`,
      );
      message = detailedMessages.join(' ');
    }

    const translatedError = t(`errors.${code}`);
    enqueueSnackbar(
      hasDetailedErrors
        ? message
        : translatedError?.includes('%')
          ? parsed.detail
          : translatedError || message,
      { variant: 'error' },
    );
  };
}
